import { createFileRoute } from "@tanstack/react-router";
import { Login } from "./-login.body";

export const Route = createFileRoute("/login")({ component: Login });
